import { getNoteGenerationEngineConfig } from '../../config';

/** Call only behind the body's existing surface/arm guards. */
export function resetSectionalRestoreAttempts(sessionId: string): void {
  getNoteGenerationEngineConfig().reactions.resetSectionalRestoreAttempts(sessionId);
}

/** The caller owns the cap check and any failure toast. */
export function recordSectionalRestoreAttempt(sessionId: string, next: number): void {
  getNoteGenerationEngineConfig().reactions.recordSectionalRestoreAttempt(
    sessionId,
    next
  );
}
